import 'jquery';

import common from './routes/common';
common.init()

import videoLazyLoad from './util/videoLazyLoad';
videoLazyLoad.init();

import Menu from './util/Menu';

import modals from './modal'
modals.init()

import team from './team';
team.init();

// import carousel from './carousel';
// carousel.init();

import practiceAreas from './carousel/practiceAreas';
practiceAreas.init();

import reviews from './carousel/reviews';
reviews.init();

import animations from './animations';
animations.init();

import navigation from './navigation';
navigation.init();
	// Menu
	const menu = new Menu(
		[
			'header button.header__burger-btn',
      'nav.nav-primary div.menu-fixed-navigation-container a',
		],
		[
			'header.banner',
      'nav.nav-primary div.menu-fixed-navigation-container a',
		],
		[
			'div.acuity--hero-copy',
			'div.acuity--about',
			'div.acuity--approach-container',
			'div.acuity--approach-animations',
			'div.video-image--background',
      'div.acuity--practice-areas-container',
			'div.acuity--practice-areas-three',
      'div.acuity--practice-area',
			'div.acuity--networks-clients-container',
			'div.acuity--select-clients-container',
			'div.acuity--quotes-container',
      'div.contact--container',
			'div.acuity--team',
			'div.acuity--team-experience',
      'div.contact--container',
		]
	);
	menu.enable();
